import React from 'react';

const WavyLine = () => {
  // SVG component for a complex wavy line background.
  // Uses a mask with a vertical linear gradient to fade out towards the bottom.
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 1269 1312"
      preserveAspectRatio="xMidYMin slice"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        minHeight: '800px',
        minWidth: '100%',
        position: 'absolute',
        bottom: '0px'
      }}
      // Retained aria-hidden from the previous implementation for accessibility
      aria-hidden="true"
    >
      <mask
        id="mask0_29_7"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="1269"
        height="1312"
        style={{ maskType: 'alpha' }} // Converted style attribute
      >
        {/* The rect uses the modified gradient below to create the fade effect */}
        <rect width="1269" height="1312" fill="url(#paint0_linear_29_7)"></rect>
      </mask>
      <g mask="url(#mask0_29_7)">
        <path
          fillRule="evenodd" // Converted attribute
          clipRule="evenodd" // Converted attribute
          d="M0 53L42.3 76.9259C84.6 100.852 169.2 148.704 253.8 154.685C338.4 160.667 423 124.778 507.6 142.722C592.2 160.667 676.8 232.444 761.4 244.407C846 256.37 930.6 208.519 1015.2 172.63C1099.8 136.741 1184.4 112.815 1226.7 100.852L1269 88.8889L1269 1108H1226.7C1184.4 1108 1099.8 1108 1015.2 1108C930.6 1108 846 1108 761.4 1108C676.8 1108 592.2 1108 507.6 1108C423 1108 338.4 1108 253.8 1108C169.2 1108 84.6 1108 42.3 1108H0V53Z"
          fill="url(#paint1_linear_29_7)" // Fill color gradient remains the same
        ></path>
      </g>
      <defs>
        {/* Modified mask gradient to fade vertically from 0.15 opacity to 0, starting the fade earlier */}
        <linearGradient
          id="paint0_linear_29_7"
          x1="70%" // Vertical gradient
          y1="0%"  // Starts at the top
          x2="70%" // Vertical gradient
          y2="100%" // Ends at the bottom
          gradientUnits="userSpaceOnUse" // Use bounding box units
        >
          {/* Using white color as it doesn't matter for alpha mask */}
          {/* Reduced start opacity for slightly more transparency */}
          <stop stopColor="#FFFFFF" stopOpacity="0.15"></stop> {/* Start opacity 0.15 at the top (0%) */}
          {/* Make the fade to 0 opacity complete earlier (e.g., at 70% height) */}
          <stop offset="0.7" stopColor="#FFFFFF" stopOpacity="0"></stop> {/* End opacity 0 at 70% */}
          {/* Implicitly stays at opacity 0 from 70% to 100% */}
        </linearGradient>
        {/* Original fill color gradient remains unchanged */}
        <linearGradient
          id="paint1_linear_29_7"
          x1="0"
          y1="0"
          x2="1269"
          y2="1312"
          gradientUnits="userSpaceOnUse" // Converted attribute
        >
          <stop stopColor="#115989"></stop> {/* Converted attribute */}
          <stop offset="0.153486" stopColor="#2C5192"></stop> {/* Converted attribute */}
          <stop offset="1" stopColor="#C428C1"></stop> {/* Converted attribute */}
        </linearGradient>
      </defs>
    </svg>
  );
};

export default WavyLine;
